import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
const SIZE = {
    thumb: { w: 92, h: 92 },
    card: { w: 400, h: 300 },
    hero: { w: 720, h: 560 },
};
export function ProductPhoto({ src, alt, size = "card", fit = "cover", className, priority, }) {
    const { w, h } = SIZE[size];
    return (_jsx("img", { "data-slot": "product-photo", "data-size": size, src: src, alt: alt, width: w, height: h, loading: priority ? "eager" : "lazy", decoding: "async", className: cn("h-full w-full", fit === "contain" ? "object-contain" : "object-cover", className) }));
}
